import { Component, Input, OnInit } from "@angular/core";

@Component({
  selector: "app-nodatafound",
  templateUrl: "./nodatafound.component.html",
  styleUrls: ["./nodatafound.component.scss"],
})
export class NodatafoundComponent implements OnInit {
  @Input() productIcon: string = "";
  @Input() noDataText: string = "";
  @Input() isPlatformIntegrated: boolean = true;
  @Input() isInteract: boolean = false;
  @Input() isSocialDraft: boolean = false;

  constructor() {}

  ngOnInit(): void {}
}
